var App = App || {};

App.Video = (function ($) {
    "use strict";

    var isMobile = function () {
        return window.innerWidth < 768;
    };

    function initMoreVideos() {
        var getCount = function () {
            if (isMobile()) {
                return 2;
            }

            return 5;
        }

        $(".video-load-more").on("click", function (event) {
            event.preventDefault();

            var $this = $(this);
            var id = $this.data("id");
            var count = getCount();

            var $moreVideos = $(`#more-videos-${id}`);
            var $targetParent = $(`#more-video-container-${id}`);

            var moreVideoElements = $moreVideos.children();

            if (!moreVideoElements.length) {
                $this.parent().animate({ height: 0 }, 200);
                return;
            }

            var $wrapper = $("<div class='more-videos-inserted mb-n2 mb-md-n4'></div>");

            let i = 0;
            for (; i < count; i++) {
                if (i >= moreVideoElements.length) {
                    break;
                }
                var ele = $(moreVideoElements[i]).detach();
                $wrapper.append(ele);
            }

            $targetParent.append($wrapper);
            var height = 120 * i;

            setTimeout(function () {
                $wrapper.css("max-height", height);
            }, 1);

            if (!$moreVideos.children().length) {
                $this.parent().animate({ height: 0 }, 200);
            }
        });

      
      
        $(".showtranscriptlink").on("click", function () {
            $(".photo_video_transcript, .hidetranscriptlink").show();
            $(this).hide();
        });

        $(".hidetranscriptlink").on("click", function () {
            $(".photo_video_transcript, .hidetranscriptlink").hide();
            $(".showtranscriptlink").show();
        });
    }

    function initGridVideos() {
        var getCount = function () {
            if (isMobile()) {
                return 2;
            }

            return 6;
        }

        if (isMobile()) {
            // On Mobile, trim the number of initially visible grid items
            var initialVisible = 5;
            $(".video-grid-container").each(function () {
                var $this = $(this);
                var id = $this.data("id");
                var $moreVideos = $(`#grid-videos-${id}`);

                var gridElements = $(".video-grid-container").children();
                if (gridElements.length > initialVisible) {
                    var toAppend = gridElements.slice(initialVisible);
                    if (toAppend.length) {
                        var list = $.makeArray(toAppend);
                        list.reverse();
                        for (var element of list) {
                            var $ele = $(element);
                            $ele.detach();
                            $moreVideos.prepend($ele);
                        }
                    }
                }
            });
        }

        $(".grid-load-more").on("click", function (event) {
            event.preventDefault();

            var $this = $(this);
            var id = $this.data("id");
            var count = getCount();

            var $moreVideos = $(`#grid-videos-${id}`);
            var $targetParent = $(`#grid-video-container-${id}`);

            var moreVideoElements = $moreVideos.children();

            if (!moreVideoElements.length) {
                $this.parent().animate({ height: 0 }, 200);
                return;
            }

            var $wrapper = $("<div class='grid-videos-inserted row'></div>");

            let i = 0;
            for (; i < count; i++) {
                if (i >= moreVideoElements.length) {
                    break;
                }
                var ele = $(moreVideoElements[i]).detach();
                $wrapper.append(ele);
            }

            var $colWrapper = $("<div class='col-12'></div>");
            $colWrapper.append($wrapper);

            $targetParent.append($colWrapper);
            var multiplier = isMobile() ? i : Math.ceil(i / 3.0);
            var height = 400 * multiplier;

            setTimeout(function () {
                $wrapper.css("max-height", height);
            }, 1);

            if (!$moreVideos.children().length) {
                $this.parent().animate({ height: 0 }, 200);
            }
        });
    }

  

    return {
        initMoreVideos: initMoreVideos,
        initGridVideos: initGridVideos,
    };

})(jQuery);

$(function () {
    App.Video.initMoreVideos();
    App.Video.initGridVideos();
});